<style lang="stylus">
    .clickEvent-mask
        modal-mask()
        .clickEvent-modal
            width 450px
            .clickEvent-container
                position relative
                padding 0 20px 30px 20px
                .ban-cover
                    position absolute
                    left 0
                    top 0
                    width calc(100% - 60px)
                    height 24px
                    margin 0 20px 0 40px
                    z-index 1
                    background-color #ddd
                    opacity 0.2
                    cursor not-allowed
                .clickEvent-des
                    font-size 12px
                    margin 10px 0
                .clickEvent-radiogroup
                    .clickEvent-height-radio
                        height 60px
                .clickEvent-hylinklist
                    position absolute
                    top 90px
                    left 0
                    width 100%
                .clickEvent-actionslist
                    position absolute
                    top 150px
                    left 0
                    width 100%
                .ivu-select-dropdown
                    max-height 400px
                    overflow-y auto
                .clickEvent-Dropdown
                    width calc(100% - 60px)
                    margin 0 20px 0 40px
                    .clickEvent-Dropdown-showbox
                        position relative
                        width 100%
                        border 1px solid #dcdee2
                        font-size 12px
                        padding-left 10px
                        height 24px
                        line-height 24px
                        display flex
                        align-items center
                        span
                            flex 1
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap

                        i
                            margin-right 5px
</style>

<template>
    <div class="clickEvent-mask">
        <Dialog class="clickEvent-modal" :title="$t('title')" :isShow="true" :showFooter="true" @ok="confirm" @close="cancel">
            <div class="clickEvent-container">
                <p class="clickEvent-des">{{ $t("description") }}</p>
                <RadioGroup class="clickEvent-radiogroup" v-model="clickRadio" vertical>
                    <Radio :label="0">
                        <span>{{ $t("edrawDefalut") }}</span>
                    </Radio>
                    <Radio :label="1" class="clickEvent-height-radio" :disabled="hyperlinkList.length == 0">
                        <span>{{ $t("hylink") }}</span>
                    </Radio>
                    <Radio :label="2" :disabled="actionsList.length == 0">
                        <span>{{ $t("actions") }}</span>
                    </Radio>
                </RadioGroup>
                <div class="clickEvent-hylinklist">
                    <Dropdown trigger="click" class="clickEvent-Dropdown" @on-click="setHylinkData">
                        <div class="clickEvent-Dropdown-showbox">
                            <span v-text="hyperlinkList.length != 0 ? hyperlinkList[hylinkIndex]._description : ''"></span>
                            <Icon type="ios-arrow-down"></Icon>
                        </div>
                        <DropdownMenu slot="list">
                            <DropdownItem v-for="(item, index) in hyperlinkList" :key="index" :name="index">{{ item._description }}</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                    <div v-if="hyperlinkList.length == 0" class="ban-cover"></div>
                </div>
                <div class="clickEvent-actionslist">
                    <Dropdown trigger="click" class="clickEvent-Dropdown" @on-click="setActionsData">
                        <div class="clickEvent-Dropdown-showbox">
                            <span v-text="actionsList.length != 0 ? actionsList[actionsIndex].name : ''"></span>
                            <Icon type="ios-arrow-down"></Icon>
                        </div>
                        <DropdownMenu slot="list">
                            <DropdownItem v-for="(item, index) in actionsList" :key="index" :name="index">{{ item.name }}</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                    <div v-if="actionsList.length == 0" class="ban-cover"></div>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";
    declare var STR4_GoHyp: string;
    declare var STR4_DoAct: string;

    @Component({
        components: {
            Dialog,
        },
    })
    export default class ClickEvent extends Vue {
        @Inject()
        ["iviewInputBlur"];
        inputLocker: boolean = false;
        clickRadio: number = 0;
        hyperlinkList: Array<any> = [];
        actionsList: Array<any> = [];
        hylinkIndex: number = 0;
        actionsIndex: number = 0;

        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }
        setHylinkData(v) {
            this.hylinkIndex = v;
        }
        setActionsData(v) {
            console.log("action : " + v);
            this.actionsIndex = v;
        }

        confirm() {
            let index = 0;
            if (this.clickRadio == 1) index = this.hylinkIndex;
            else if (this.clickRadio == 2) index = this.actionsIndex;
            window["_view"].setClickEvent(this.clickRadio, index);
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        cancel() {}
        mounted() {
            let hyperlinkList = [],
                actionsList = [];
            if (this.activeFloatItem != -1) {
                hyperlinkList = this.floatMenuList[this.activeFloatItem].hyperlinkList._hyperlinks;
                actionsList = this.floatMenuList[this.activeFloatItem].actionsList._actions;
            } else if (this.activeShapeID != 0) {
                for (let i = 0; i < this.floatMenuList.length; ++i) {
                    if (this.floatMenuList[i].id == this.activeShapeID) {
                        hyperlinkList = this.floatMenuList[i].hyperlinkList._hyperlinks;
                        actionsList = this.floatMenuList[this.activeFloatItem].actionsList._actions;
                        break;
                    }
                }
            }
            this.hyperlinkList = hyperlinkList;

            let arr = actionsList.map((v: any, k) => {
                return {
                    name: v._menuDisp || v._menu._string,
                    id: v._id,
                    isVisible: !v._invisible._bool,
                    isAble: !v._disable._bool,
                    isCheck: v._check._bool,
                };
            });
            this.actionsList = arr.filter((v: any, k) => {
                return v.isVisible && v.isAble;
            });

            let initData = window["_view"].initClickEvent();
            this.clickRadio = initData[0]; //clickRadio
            this.hylinkIndex = initData[1]; //hylinkIndex
            this.actionsIndex = initData[2]; //actionsIndex
        }
        beforeDestroy() {}
        created() {}

        get activeFloatItem() {
            return this.$store.state.dialog.activeFloatItem;
        }
        get floatMenuList() {
            return this.$store.state.dialog.floatMenuList;
        }
        get activeShapeID() {
            return this.$store.state.shape.id;
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "点击事件",
    "description": "映射鼠标左键事件",
    "edrawDefalut": "亿图默认",
    "hylink": "超链接",
    "actions": "形状动作"
  },
  "en": {
    "title": "Click Event",
    "description": "Map Mouse left click event to",
    "edrawDefalut": "EdrawMax Default",
    "hylink": "Hyperlink",
    "actions": "Shape Action"
  },
  "es": {
    "title": "Haga clic en Evento",
    "description": "Asignar evento de clic izquierdo del mouse a",
    "edrawDefalut": "EdrawMax predeterminado",
    "hylink": "Hipervínculo",
    "actions": "Acción de forma"
  },
  "jp": {
    "title": "クリックイベント",
    "description": "マウスの左クリックイベントをマッピング",
    "edrawDefalut": "Edrawデフォルト",
    "hylink": "ハイパーリンク",
    "actions": "シェイプ アクション"
  },
  "fr": {
    "title": "Cliquez événement",
    "description": "Mapper les événements du bouton gauche de la souris",
    "edrawDefalut": "Edraw par défaut",
    "hylink": "Hyperlien",
    "actions": "Action de forme"
  },
  "pt": {
    "title": "Clicar em Evento",
    "description": "Mapa do evento do botão esquerdo do mouse para",
    "edrawDefalut": "EdrawMax Padrão",
    "hylink": "Hiperlink",
    "actions": "Ação de Forma"
  },
  "de": {
    "title": "Klicken Sie auf Ereignis",
    "description": "Ereignisse mit der linken Maustaste zuordnen",
    "edrawDefalut": "EdrawMax Standard",
    "hylink": "Hyperlink",
    "actions": "Formaktion"
  },
  "it": {
    "title": "Fare clic su Evento",
    "description": "Mappa eventi del pulsante sinistro del mouse",
    "edrawDefalut": "Edraw per impostazione predefinita",
    "hylink": "Hiperlink",
    "actions": "Azione di forma"
  },
  "tw": {
    "title": "點擊事件",
    "description": "映射鼠標左鍵事件",
    "edrawDefalut": "Edraw默認",
    "hylink": "超連結",
    "actions": "形狀動作"
  },
  "kr": {
    "title": "이벤트 클릭",
    "description": "마우스 왼쪽 클릭 이벤트 매핑 대상",
    "edrawDefalut": "EdrawMax 기본",
    "hylink": "하이퍼링크",
    "actions": "도형 동작"
  }
}
</i18n>
